module.exports = __webpack_public_path__ + "img/bessac_bg_01_.74af27ee.jpg";